import React from "react";
import * as textGridStyles from "./TextGrid.module.css";
import Card from "../Card";

const TextGrid = ({ props }) => {
  const { background, textCards, style, howManyCopyBlocksInARow } = props;

  return (
    <div
      className={`${textGridStyles.textGrid} ${textGridStyles[background]} ${
        howManyCopyBlocksInARow
          ? textGridStyles[`rows${howManyCopyBlocksInARow}`]
          : ""
      }`}
    >
      <div className={textGridStyles.content}>
        <div className={textGridStyles.copyBlocks}>
          {textCards &&
            textCards.map((item, index) => (
              <Card key={index} {...item} style={style} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default TextGrid;
